// Pure stat helpers, shared by the server (authoritative results) and the
// frontend (display). No secrets, no Node APIs.
import type { RaceResult } from "./types";

export function accuracy(correct: number, attempts: number): number {
  if (attempts <= 0) return 0;
  return correct / attempts;
}

export function avgAnswerMs(sumMs: number, answered: number): number {
  if (answered <= 0) return 0;
  return Math.round(sumMs / answered);
}

export function formatMs(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return "—";
  const totalSeconds = ms / 1000;
  if (totalSeconds < 60) return `${totalSeconds.toFixed(1)}s`;
  const m = Math.floor(totalSeconds / 60);
  const s = Math.round(totalSeconds % 60);
  return `${m}m ${s.toString().padStart(2, "0")}s`;
}

export function formatPct(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}

/** Fraction of the track a racer has covered (0..1), for the visual position. */
export function trackFraction(correctCount: number, finishLine: number): number {
  if (finishLine <= 0) return 0;
  return Math.min(1, Math.max(0, correctCount / finishLine));
}

export function summarize(args: {
  correctCount: number;
  attempts: number;
  finishLine: number;
  totalMs: number;
  sumAnswerMs: number;
  fastestMs: number;
}): RaceResult {
  return {
    correctCount: args.correctCount,
    attempts: args.attempts,
    finishLine: args.finishLine,
    accuracy: accuracy(args.correctCount, args.attempts),
    totalMs: args.totalMs,
    avgAnswerMs: avgAnswerMs(args.sumAnswerMs, args.attempts),
    fastestMs: Number.isFinite(args.fastestMs) ? args.fastestMs : 0,
  };
}
